import { EntityType } from '@frontend/common';

const ENTITY_TYPE_KEYS: [EntityType, string[]][] = [
    [EntityType.ACCOUNT, ['account_id']],
    [EntityType.ATTRIBUTE, ['attribute_id']],
    [EntityType.ATTRIBUTE_VALUE, ['value_id']],
    [EntityType.BASKET, ['basket_id']],
    [EntityType.BRANDING, ['branding_id']],
    [EntityType.BUDGET, ['budget_id']],
    [EntityType.CERTIFICATE, ['certificate_id']],
    [EntityType.COLLI, ['colli_id']],
    [EntityType.CONSTRAINT, ['constraint_id']],
    [EntityType.COST_CENTER, ['cost_center_id']],
    [EntityType.DECEASED, ['deceased_id']],
    [EntityType.DEVICE, ['device_id']],
    [EntityType.DOCUMENT, ['document_id', 'privacy_policy_document_id', 'notification_logo_document_id']],
    [EntityType.EQUIPMENT, ['equipment_id']],
    [EntityType.EQUIPMENT_GROUP, ['equipment_group_id']],
    [EntityType.FUNCTIONALITY, ['functionality_id']],
    [EntityType.IDENTIFICATION, ['identification_id']],
    [EntityType.IOT, ['iot_id', 'twin_iot_id', 'default_printer_id']],
    [EntityType.JOB, ['job_id']],
    [EntityType.LABEL_TEMPLATE, ['template_id', 'label_template_id']],
    [EntityType.LABEL_TEMPLATE_CONTENT, ['content_id']],
    [EntityType.LOCKER, ['locker_id']],
    [EntityType.MODULE, ['module_id', 'current_module_id']],
    [EntityType.MODULE_TEMPLATE, ['module_template_id']],
    [EntityType.NOTIFICATION, ['notification_id']],
    [EntityType.NOTIFICATION_CONTENT, ['notification_content_id']],
    [EntityType.NOTIFICATION_TEMPLATE, ['notification_template_id']],
    [EntityType.ORDER, ['order_id']],
    [EntityType.PACKAGE, ['package_id', 'drop_off_package_id', 'pick_up_package_id', 'dependent_package_id']],
    [EntityType.PLAYLIST, ['playlist_id', 'default_playlist_id']],
    [EntityType.PLAYLIST_ITEM, ['playlist_item_id']],
    [EntityType.PROBLEM, ['problem_id', 'equipment_problem_id']],
    [EntityType.PRODUCT, ['product_id', 'kit_id', 'products']],
    [
        EntityType.PRODUCT_CATEGORY,
        ['category_id', 'product_category_id', 'default_product_category_id', 'default_product_root_category_id', 'default_shop_product_root_category_id']
    ],
    [EntityType.PRODUCT_GROUP, ['product_group_id']],
    [EntityType.QUESTION, ['question_id']],
    [EntityType.QUESTIONNAIRE, ['questionnaire_id', 'consume_questionnaire_id', 'return_questionnaire_id']],
    [EntityType.REPORT, ['report_id']],
    [EntityType.REVIEW, ['review_id']],
    [EntityType.ROLE, ['role_id', 'default_user_account_role_id']],
    [EntityType.SCHEDULE, ['schedule_id']],
    [EntityType.SLOT, ['slot_id', 'current_slot_id']],
    [EntityType.SLOT_TEMPLATE, ['slot_template_id']],
    [EntityType.SPOT, ['spot_id', 'default_spot_id', 'current_spot_id']],
    [EntityType.TRANSACTION, ['transaction_id']],
    [
        EntityType.USER,
        [
            'user_id',
            'cc_user_id',
            'drop_off_user_id',
            'pick_up_user_id',
            'withdraw_user_id',
            'return_user_id',
            'backup_notification_user_id',
            'supervisor_user_id',
            'owner_id',
            'sender_id',
            'receiver_id',
            'users',
            'senders',
            'receivers',
            'owners',
            'sender_ids',
            'receiver_ids',
            'initiated_by_id',
            'dropped_off_by_id',
            'picked_up_by_id'
        ]
    ],
    [
        EntityType.USER_GROUP,
        [
            'group_id',
            'user_group_id',
            'access_control_user_group_id',
            'default_user_group_id',
            'open_drop_off_senders_user_group_id',
            'open_drop_off_receivers_user_group_id',
            'open_drop_off_senders_user_group_ids',
            'open_drop_off_receivers_user_group_ids'
        ]
    ],
    [EntityType.USER_INTERFACE, ['user_interface_id', 'default_user_interface_id']],
    [
        EntityType.WORKFLOW,
        [
            'workflow_id',
            'transaction_workflow_id',
            'colli_workflow_id',
            'package_workflow_id',
            'deceased_workflow_id',
            'drop_off_package_workflow_id',
            'pick_up_package_workflow_id',
            'drop_off_moved_package_workflow_id',
            'pick_up_moved_package_workflow_id',
            'courier_pick_up_package_workflow_id',
            'destination_pick_up_package_workflow_id',
            'source_drop_off_package_workflow_id',
            'courier_drop_off_package_workflow_id'
        ]
    ],
    [EntityType.WIZARD, ['wizard_id']]
];

const ENTITY_TYPE_BY_KEY = new Map<string, EntityType>(ENTITY_TYPE_KEYS.flatMap(([entityType, keys]) => keys.map((key) => [key, entityType] as const)));

/** Entity type referenced by an object field (e.g. `current_spot_id` → SPOT). Platform counterpart of the legacy ObjectBadgeMapper. */
export function platformEntityTypeForKey(key: string): EntityType | undefined {
    return ENTITY_TYPE_BY_KEY.get(key);
}
